import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { getRepaymentSchedule } from '../../../../repaymentScheduleSelectors';
import { REQUEST_CHANGE_ROUTER } from '../../../../../../iwRouter/IwRouter.actions';
import CollapsibleSection from '../../../../../ui/CollapsibleSection/CollapsibleSection';
import { FormattedCurrency } from '../../../../../../iwIntlProvider/FormattedCurrency';
import messages from './RepayRequest.messages';
import styles from './RepayRequest.module.css';
import { Dispatch } from 'redux';
import { RootState } from '@iwProvider/configureStore';
import { TAccount } from '../../../../iwocaPay.types';

type TOwnProps = {
    account: TAccount;
};

const mapStateToProps = (state: RootState, { account }: TOwnProps) => {
    const repaymentSchedule: TAccount['scheduled_payments'] =
        getRepaymentSchedule(state, account);

    /**
    if the next repayment is same as "standard" equal repayment,
    we don't need to include "next repayment" section.

    api.lending.core.services.repayment_schedule:451

    First checking for the next_repayment, if it doesn't exist all repayments are equal
    So loading the equal repayment
    */
    const nextRepaymentAmount =
        repaymentSchedule?.summary?.simplified_schedule?.next_repayment
            ?.amount ||
        repaymentSchedule?.summary?.simplified_schedule?.equal_repayments
            ?.amount;

    return {
        accountId: account.account_id,
        nextRepaymentAmount
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToEarlyRepayment: (accountId: NonNullable<TAccount['account_id']>) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/repayment/choose-amount/',
                search: `?accountId=${accountId}`
            }
        });
    }
});

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(({ goToEarlyRepayment, account, nextRepaymentAmount }) => {
    return (
        <CollapsibleSection
            data-testid="overdue-repay-request-section"
            isCollapsible={false}
            className={styles.repayRequest}
        >
            <div
                className={styles.explanation}
                data-testid="overdue-repay-request-explanation"
            >
                <span className={styles.errorIcon} />
                {nextRepaymentAmount !== undefined ? (
                    <span>
                        <FormattedMessage
                            {...messages.explanation}
                            values={{
                                amount: (
                                    <span className={styles.explanationAmount}>
                                        <FormattedCurrency
                                            value={nextRepaymentAmount}
                                        />
                                    </span>
                                )
                            }}
                        />
                    </span>
                ) : (
                    'Something went wrong. Please try again later.'
                )}
            </div>

            <button
                data-testid="overdue-repay-request-cta"
                className={styles.cta}
                onClick={() => goToEarlyRepayment(account.account_id!)}
            >
                <FormattedMessage {...messages.cta} />
            </button>
        </CollapsibleSection>
    );
});
